import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { find, isEmpty } from 'lodash'
import locationService from '../services/location.service'
import itemService from '../services/item.service'
import downloadService from '../services/download.service'
import locationApi, {
  LocationData, LocationExportBinItemsRequest, LocationListBinItemsRequest
} from '../apis/location.api'
import { ItemData } from '../apis/item.api'
import Button from '../components/Button'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import Select from '../components/Select'
import { ActionName } from '../components/Actions'
import TableHorizontal, {
  TableHorizontalHeader
} from '../components/TableHorizontal'
import InputText from '../components/InputText'

interface LocationSearchFormProps {
  onItemView: (item: ItemData, locationId: number, bin: string) => void
  onItemClear: () => void
}

interface LocationSearchFormState {
  locationId: string
  bin: string
  locations: LocationData[]
  items: ItemData[]
}

export default class LocationSearchForm
  extends Component<LocationSearchFormProps, LocationSearchFormState> {
    tableHeaders: TableHorizontalHeader[] = [
      { heading: i18n("Item code"), path: 'code' },
      { heading: i18n("Description"), path: 'description' },
      { heading: i18n("Location"), path: 'pallets.0.aliveTransfer.location.name' },
      { heading: i18n("Bin"), path: 'pallets.0.aliveTransfer.bin' },
      { heading: i18n("Quantity"), path: 'palletsQuantity' },
      { heading: i18n("Actions") }
    ]

    constructor (props: LocationSearchFormProps) {
      super(props)
      this.state = {
        locationId: '',
        bin: '',
        locations: [],
        items: []
      }
      this.handleInputChange = this.handleInputChange.bind(this)
      this.handleSearchClick = this.handleSearchClick.bind(this)
      this.handleActionClick = this.handleActionClick.bind(this)
      this.handleExportClick = this.handleExportClick.bind(this)
    }

    get locationSelectOptions () {
      return locationService.selectOptions(this.state.locations)
    }

    get itemsTableData () {
      if (!this.state.items) return []
      return itemService.locationSearchTableData(this.state.items)
    }

    get export () {
      const { items } = this.state
      return !isEmpty(items) &&
        <div className="flex justify-end mb-4">
          <Button
            text={i18n("Export")}
            onClick={this.handleExportClick} />
        </div>
    }

    listLocations () {
      locationApi.list(locations => {
        if (!locations) return
        this.setState({ locations })
      })
    }

    listBinItems () {
      const { locationId, bin } = this.state
      const id = Number(locationId)
      if (!id) return
      const payload: LocationListBinItemsRequest = {}
      if (id) payload.id = id
      if (bin) payload.bin = bin
      locationApi.listBinItems(payload, items => {
        if (!items) return
        this.setState({ items })
      })
    }

    handleInputChange (name: string, value: string) {
      if (name === 'location') this.setState({ locationId: value })
      if (name === 'bin') this.setState({ bin: value })
    }

    handleSearchClick () {
      this.setState({ items: [] })
      this.props.onItemClear()
      this.listBinItems()
    }

    handleActionClick (palletId: number, action: ActionName) {
      /**
       * Refactor required
       * Here collecting palletId instead of id of the item.
       * When search location without bin there will have multiple
       * duplicated item results. So palletId is setting as item id for
       * collecting bin.
       */
      const item = itemService.findByPalletId(this.state.items, palletId)
      if (!item || !item.pallets) return
      const firstPallet = find(item.pallets, { id: palletId })
      if (!firstPallet || !firstPallet.aliveTransfer) return
      const bin = firstPallet.aliveTransfer.bin
      if (action === 'view') {
        const { locationId } = this.state
        this.props.onItemView(item, Number(locationId), bin)
      }
    }

    handleExportClick () {
      const { locationId, bin } = this.state
      const id = Number(locationId)
      const payload: LocationExportBinItemsRequest = {}
      if (id) payload.id = id
      if (bin) payload.bin = bin
      locationApi.exportBinItems(payload, items => {
        if (!items) return
        downloadService.download(items, 'items.csv')
      })
    }

    componentDidMount () {
      this.listLocations()
    }

    render () {
      return (
        <Card>
          <PageHeading
            text={i18n("Location Search")}
            doc='items-search-items-by-location-and-bin' />
          <Row column={3}>
            <Select
              name="location"
              value={this.state.locationId}
              label={i18n("Location")}
              options={this.locationSelectOptions}
              onChange={this.handleInputChange} />
            <InputText
              name="bin"
              value={this.state.bin}
              label={i18n("Bin")}
              onChange={this.handleInputChange} />
            <div className="flex items-end mb-4">
              <Button
                text={i18n("Search")}
                full={true}
                onClick={this.handleSearchClick} />
            </div>
          </Row>
          {this.export}
          <TableHorizontal
            headers={this.tableHeaders}
            data={this.itemsTableData}
            onActionClick={this.handleActionClick} />
        </Card>
      )
    }
}
